import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import styles from './TermsOfServicePage.module.scss';

const TermsOfServicePage = () => {
  return (
    <>
      <SEO 
        title="Terms of Service - mobiyo"
        description="Read our terms of service to understand the rules and guidelines for using mobiyo's mobile application review management and AI response generation services."
        keywords="terms of service, user agreement, service terms, mobile app reviews, AI response generation"
        canonical="https://mobiyo.app/terms-of-service"
      />
      <div className={styles.container}>
        <div className={styles.content}>
          <h1>Terms of Service</h1>
          <p>Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using mobiyo's services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>
              mobiyo provides a platform for collecting and managing mobile application reviews, analyzing user feedback, and generating AI-powered responses. Our service includes:
            </p>
            <ul>
              <li>Review collection from app stores</li>
              <li>AI-powered response generation</li>
              <li>Analytics and reporting tools</li>
              <li>User management features</li>
            </ul>
          </section>

          <section>
            <h2>3. User Responsibilities</h2>
            <p>
              As a user of our service, you agree to:
            </p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account</li>
              <li>Use the service in compliance with all applicable laws</li>
              <li>Not engage in any activity that disrupts or interferes with the service</li>
            </ul>
          </section>

          <section>
            <h2>4. Service Limitations</h2>
            <p>
              We strive to provide reliable and high-quality services, but we cannot guarantee that the service will be uninterrupted, timely, secure, or error-free. We reserve the right to modify or discontinue any aspect of the service at any time.
            </p>
          </section>

          <section>
            <h2>5. Contact Information</h2>
            <p>
              For any questions regarding these Terms of Service, please contact us at:
              <br />
              Email: team@mobiyo.app
            </p>
          </section>

          <div className={styles.backLink}>
            <Link to="/">← Back to Home</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfServicePage; 
